import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

export const UpdateBanner = () => {
  const [waiting, setWaiting] = useState(null);
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let reg;
    const onFound = () => {
      const sw = reg.installing;
      sw && sw.addEventListener("statechange", () => { if (sw.state === "installed" && navigator.serviceWorker.controller) setWaiting(sw); });
    };
    navigator.serviceWorker.getRegistration().then((r) => {
      if (!r) return;
      reg = r;
      if (r.waiting && navigator.serviceWorker.controller) setWaiting(r.waiting);
      r.addEventListener("updatefound", onFound);
    });
    const onCtrl = () => window.location.reload();
    navigator.serviceWorker.addEventListener("controllerchange", onCtrl);
    return () => navigator.serviceWorker.removeEventListener("controllerchange", onCtrl);
  }, []);
  if (!waiting) return null;
  return (
    <button onClick={() => waiting.postMessage({ type: "SKIP_WAITING" })} data-testid="update-banner"
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2 bg-onyx text-white text-sm font-semibold px-4 py-2.5 rounded-full shadow-xl border border-gold/50 hover:bg-black fade-up">
      <RefreshCw className="w-4 h-4 gold-text" /> Nova versão disponível — toque para atualizar
    </button>
  );
};
